import { render, staticRenderFns } from "./NumberFlip.vue?vue&type=template&id=984b9b66&scoped=true&"
import script from "./NumberFlip.vue?vue&type=script&lang=js&"
export * from "./NumberFlip.vue?vue&type=script&lang=js&"
import style0 from "./NumberFlip.vue?vue&type=style&index=0&id=984b9b66&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "984b9b66",
  null
  
)

export default component.exports